import React from 'react';
import './StatusBadge.css';

/**
 * Displays a color-coded badge for PR event status.
 * Reusable across Dashboard, PR list, and PR detail screens.
 */
const STATUS_CONFIG = {
  PASSED:  { label: 'Passed',  className: 'badge-success' },
  FAILED:  { label: 'Failed',  className: 'badge-error' },
  PENDING: { label: 'Pending', className: 'badge-warning' },
  OPEN:             { label: 'Open',             className: 'badge-info' },
  CLOSED:           { label: 'Closed',           className: 'badge-muted' },
  MERGED:           { label: 'Merged',           className: 'badge-success' },
  REVIEW_COMPLETED: { label: 'Review Completed', className: 'badge-review' },
};

function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || { label: status, className: 'badge-muted' };

  return (
    <span className={`status-badge ${config.className}`}>
      {config.label}
    </span>
  );
}

export default StatusBadge;
